(() => {
  'use strict';
  const categories = ['analytics', 'marketing', 'preferences'];
  const methods = {analytics: 'analyticsProcessingAllowed', marketing: 'marketingAllowed', preferences: 'preferencesProcessingAllowed'};
  let blocked = false;
  function state() {
    try {
      const api = window.Shopify?.customerPrivacy;
      const consent = api?.currentVisitorConsent?.();
      if (!consent) throw new Error('unavailable');
      const choices = Object.fromEntries(categories.map(key => [key, ['yes', 'no'].includes(consent[key]) ? consent[key] : '']));
      const allowed = Object.fromEntries(categories.map(key => [key, !blocked && choices[key] === 'yes' && api[methods[key]]?.() === true]));
      return {ready: true, choices, allowed, decided: categories.every(key => choices[key] !== ''), marketingSharing: allowed.marketing && api.saleOfDataAllowed?.() === true};
    } catch {
      return {ready: false, choices: {analytics: '', marketing: '', preferences: ''}, allowed: {analytics: false, marketing: false, preferences: false}, decided: false, marketingSharing: false};
    }
  }
  const root = document.getElementById('TaplyPrivacy');
  if (!root) return;
  const banner = root.querySelector('[data-privacy-banner]');
  const dialog = root.querySelector('[data-privacy-dialog]');
  const form = root.querySelector('[data-privacy-form]');
  const statuses = root.querySelectorAll('[data-privacy-status]');
  const buttons = root.querySelectorAll('[data-privacy-action]');
  const configElement = document.getElementById('TaplyPrivacyStrings');
  if (!banner || !dialog || !form || !configElement) return;
  let strings;
  try { strings = JSON.parse(configElement.textContent); } catch { return; }
  let busy = false, loader = null, opener = null, activeError = false;
  const notify = () => document.dispatchEvent(new CustomEvent('taply:consent-changed', {detail: state()}));
  function status(message, error = false) {
    activeError = error;
    statuses.forEach(el => { el.textContent = message; el.dataset.error = String(error); });
  }
  function sync() {
    const current = state();
    banner.hidden = dialog.open || (current.decided && !activeError);
    return current;
  }
  function loadApi() {
    if (state().ready) return Promise.resolve(window.Shopify.customerPrivacy);
    if (loader) return loader;
    loader = new Promise((resolve, reject) => {
      let completed = false, timer, tries = 0;
      const timeout = setTimeout(() => finish(new Error('timeout')), 12000);
      function finish(error) {
        if (completed) return;
        completed = true; clearTimeout(timeout); clearTimeout(timer);
        if (error || !state().ready) reject(error || new Error('unavailable'));
        else resolve(window.Shopify.customerPrivacy);
      }
      function attempt() {
        if (completed) return;
        if (state().ready) { finish(); return; }
        if (typeof window.Shopify?.loadFeatures === 'function') {
          try { window.Shopify.loadFeatures([{name: 'consent-tracking-api', version: '0.2'}], finish); }
          catch (error) { finish(error); }
        } else if (++tries < 40) timer = setTimeout(attempt, 250);
        else finish(new Error('unavailable'));
      }
      attempt();
    }).finally(() => { loader = null; });
    return loader;
  }
  function setBusy(value) {
    busy = value;
    buttons.forEach(button => { button.disabled = value; });
    form.querySelectorAll('input[data-privacy-category]').forEach(input => { input.disabled = value; });
    root.setAttribute('aria-busy', String(value));
  }
  function openPreferences(trigger) {
    if (busy) return;
    opener = trigger || document.activeElement;
    const current = state();
    categories.forEach(key => { form.elements[key].checked = current.choices[key] === 'yes'; });
    status('');
    if (typeof dialog.showModal !== 'function') { status(strings.unsupported, true); banner.hidden = false; return; }
    if (!dialog.open) dialog.showModal();
    banner.hidden = true;
    dialog.querySelector('[data-privacy-close]').focus();
  }
  function closePreferences() {
    if (dialog.open) dialog.close();
  }
  window.TaplyPrivacy = Object.freeze({
    getState: state,
    allowed: category => state().allowed[category] === true,
    marketingSharingAllowed: () => state().marketingSharing,
    open: () => openPreferences(document.activeElement)
  });
  async function save(choices) {
    if (busy) return;
    const payload = Object.fromEntries(categories.map(key => [key, choices[key] === true]));
    blocked = true; notify(); setBusy(true); status(strings.saving);
    try {
      const api = await loadApi();
      await new Promise((resolve, reject) => {
        const timeout = setTimeout(() => reject(new Error('timeout')), 10000);
        try {
          api.setTrackingConsent(payload, result => {
            clearTimeout(timeout);
            if (result?.error) { reject(new Error('save')); return; }
            const current = state();
            if (!current.ready || !categories.every(key => current.choices[key] === (payload[key] ? 'yes' : 'no'))) reject(new Error('mismatch'));
            else resolve();
          });
        } catch (error) { clearTimeout(timeout); reject(error); }
      });
      blocked = false; status(''); closePreferences(); sync(); notify();
      const live = document.querySelector('[data-live-region]');
      if (live) live.textContent = strings.saved;
    } catch {
      status(strings.error, true);
      banner.hidden = dialog.open;
      notify();
    } finally { setBusy(false); }
  }
  root.addEventListener('click', event => {
    const button = event.target.closest('[data-privacy-action]');
    if (button && !busy) {
      const action = button.dataset.privacyAction;
      if (action === 'accept') save({analytics: true, marketing: true, preferences: true});
      else if (action === 'reject') save({analytics: false, marketing: false, preferences: false});
      else if (action === 'manage') openPreferences(button);
    }
    if (event.target.closest('[data-privacy-close]')) closePreferences();
  });
  form.addEventListener('submit', event => {
    event.preventDefault();
    save(Object.fromEntries(categories.map(key => [key, form.elements[key].checked])));
  });
  dialog.addEventListener('close', () => { sync(); opener?.focus?.(); });
  document.addEventListener('click', event => {
    const trigger = event.target.closest('[data-privacy-open]');
    if (trigger) { event.preventDefault(); openPreferences(trigger); }
  });
  document.addEventListener('visitorConsentCollected', () => { if (!busy) { sync(); notify(); } });
  document.addEventListener('visibilitychange', () => { if (document.visibilityState === 'visible' && !busy) { sync(); notify(); } });
  window.addEventListener('pageshow', () => { if (!busy) { sync(); notify(); } });
  sync();
  loadApi().then(() => { sync(); notify(); }).catch(() => { status(strings.unavailable, true); banner.hidden = false; });
})();
